<template>
  <component :is="Default">
    <template slot="buttons">
      <div class="buttons">
        <button class="loose thin" @click="$router.push('/landing')">
          Dashboard
        </button>
        <button class="loose transparent thin" @click="$logout">log out</button>
      </div>
    </template>
    <div class="d-flex filters">
      <v-select
        placeholder="Select Competition"
        :options="competitions"
        label="name"
        v-model="selectedCompetition"
        class="w-45"
        :clearable="false"
      />
      <v-select
        placeholder="Select Round"
        :options="rounds"
        v-model="selectedRound"
        class="w-45"
        :clearable="false"
      />
    </div>

    <div class="competitions">
      <div
        v-for="(f, index) in filteredMatches"
        :key="index"
        @click="select(f)"
        class="mt-20"
        :class="{ clickable: !f.meta || (!f.meta.isBye && !f.meta.isTba) }"
      >
        <Match :match="f" />
      </div>
    </div>
  </component>
</template>

<script>
import moment from "moment";
import range from "lodash/range";
import Default from "@/layouts/default";
import Match from "@/components/MatchCard";
import { finalRounds } from "@/utils/constants";

export default {
  name: "SelectFixture",
  components: {
    Match,
  },
  data() {
    return {
      Default,
      competitions: [],
      matches: [],
    };
  },
  computed: {
    selectedCompetition: {
      get() {
        return this.$store.state.match.currentCompetition;
      },
      set(newValue) {
        this.$store.commit("match/CURRENT_COMPETITION", newValue);
      },
    },
    selectedRound: {
      get() {
        return this.$store.state.match.currentRound;
      },
      set(newValue) {
        this.$store.commit("match/CURRENT_ROUND", newValue);
      },
    },
    rounds() {
      if (this.selectedCompetition) {
        const regularRoundsMapped = range(
          1,
          this.selectedCompetition.regularSeasonRounds + 1,
        ).map((number) => ({
          label: `Round ${number}`,
          type: "Regular",
          number,
        }));
        const finalRoundsMapped =
          finalRounds[this.selectedCompetition.finalSeasonRounds];
        let allRounds = [{ label: "Any Round" }];
        if (regularRoundsMapped && regularRoundsMapped.length > 0)
          allRounds = allRounds.concat(regularRoundsMapped);
        if (finalRoundsMapped && finalRoundsMapped.length > 0)
          allRounds = allRounds.concat(finalRoundsMapped);

        return allRounds;
      }
      return [];
    },
    filteredMatches() {
      if (this.selectedRound && this.selectedRound.number) {
        return this.matches.filter(
          (match) =>
            match.round.number === this.selectedRound.number &&
            match.round.type === this.selectedRound.type,
        );
      } else {
        return this.matches;
      }
    },
  },
  mounted() {
    this.$store.commit("LOADING", true);
    this.$http
      .get("/nrl/api/v1/elite/competitions")
      .then((response) => {
        if (response) {
          this.competitions = response.data.data;
          if (this.competitions.length > 0 && !this.selectedCompetition) {
            this.selectedCompetition = this.competitions[0];
          } else {
            this.getMatches(this.selectedCompetition._id);
          }
        }
        // this.$store.commit("LOADING", false);
      })
      .catch((e) => {
        this.$notify.error({
          title: "Error",
          message:
            e.response && e.response.data && e.response.data.message
              ? e.response.data.message
              : "There has been an error",
        });
        this.$store.commit("LOADING", false);
      });
  },
  methods: {
    getMatches(_id) {
      this.$store.commit("LOADING", true);
      this.$http
        .get(`/nrl/api/v1/elite/competitions/${_id}/matches`)
        .then((response) => {
          if (response) {
            this.matches = response.data.data;
          }
          this.$store.commit("LOADING", false);
        })
        .catch((e) => {
          this.$notify.error({
            title: "Error",
            message:
              e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : "There has been an error",
          });
          this.$store.commit("LOADING", false);
        });
    },
    select(match) {
      if (match.meta && (match.meta.isBye || match.meta.isTba)) return;
      else
        this.$router.push({ name: "matchevents", params: { id: match._id } });
    },
  },
  watch: {
    selectedCompetition: function(val) {
      this.getMatches(val._id);
      const upcomingMatch = this.matches.find((match) =>
        moment().isSameOrBefore(match.dateTime, "day"),
      );
      if (upcomingMatch && this.rounds.length > 0) {
        this.selectedRound = this.rounds.find(
          (r) =>
            r.number === upcomingMatch.round.number &&
            r.type === upcomingMatch.round.type,
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.w-45 {
  width: 45%;
}

.filters {
  width: 100%;
  justify-content: space-between;

  @media (max-width: 400px) {
    flex-direction: column;

    .w-45 {
      width: 100%;
      margin-bottom: 10px;
    }

    margin-top: 20px;
    margin-bottom: 20px;
  }
}

::v-deep input {
  font-size: 1rem;
  color: $black;

  &::placeholder {
    font-size: 1rem;
  }
}
</style>
